/*
 * "Open in the Yekkada app" bridge for links in WhatsApp / email (the daily fleet summary's
 * "View trips" button). A WhatsApp template URL button only accepts an https URL, so the button
 * points at https://www.yekkada.com/app/reports (see OpenInApp.jsx), and that page hands the
 * user over to the Android app's custom-scheme deep link, yekkada://reports.
 *
 * On Android it navigates to a Chrome intent:// URL: Android opens the app if it's installed,
 * otherwise the browser follows S.browser_fallback_url (the Play Store listing). Other platforms
 * have no app, so they go straight to the web page.
 */

export const ANDROID_PACKAGE = "com.satyology.yekkada";
export const APP_SCHEME = "yekkada";
export const PLAY_STORE_URL = `https://play.google.com/store/apps/details?id=${ANDROID_PACKAGE}`;

/** App-link targets this bridge knows: app host (yekkada://<host>) → web page for non-Android. */
export const APP_LINK_TARGETS = {
  reports: { webPath: "/reports" },
};

export function isAndroid(userAgent) {
  return /android/i.test(userAgent || "");
}

/** yekkada://<target> as a Chrome intent URL, falling back to the Play Store when not installed. */
export function androidIntentUrl(target, fallbackUrl = PLAY_STORE_URL) {
  return (
    `intent://${target}#Intent;scheme=${APP_SCHEME};package=${ANDROID_PACKAGE};` +
    `S.browser_fallback_url=${encodeURIComponent(fallbackUrl)};end`
  );
}
